













import _, { flatMap } from 'lodash';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { FISKAL_MODE_ENABLED } from '@/main/store/getterTypes';
import { NAME as POKL_DOKLAD } from '@/modules/uzaverka/poklDoklad/constants';
import { NAME as PARTS_INVENTORY_ADJUSTMENTS } from '@/modules/sklad/constants';
import { NAME as EVENT_CONFIGURATION } from '@/modules/ciselnik/DialogueMarketing/eventconfiguration/constants';
import { NAME as EVENT_FREQUENCY } from '@/modules/ciselnik/DialogueMarketing/eventfrequency/constants';
import { NAME as COMMUNICATION_EVENT_CONFIGURATION } from '@/modules/ciselnik/DialogueMarketing/CommunicationEventConfiguration/constants';
import { NAME as ND_OBJEDNAVKA } from '@/modules/sklad/ndObjednavka/constants';
import { NAME as PR_ORDERS } from '@/modules/sklad/PROrders/constants';
import { NAME as PR_INVOICE } from '@/modules/sklad/PRInvoice/constants';
import { NAME as PR_RETURN } from '@/modules/sklad/PRReturn/constants';
import { NAME as SERVICE_HISTORY } from '@/modules/administrace/serviceOrderHistory/constants';
import { NAME as SERVICE_DUE_DETAILS } from '@/modules/administrace/serviceDueDetails/constants';

import MenuItemComponent from './MenuItem.vue';
import { menuTree } from './menuTree';
import { MenuItem } from './menu';
import { ALTERNATIVY_VOJ } from '@/modules/administrace/organizacniJednotky/constants';
import { IncludedInOrderList, ServiceOrder} from './constants';

export default Vue.extend({
	name: 'MenuComponent',
	components: { MenuItem: MenuItemComponent },
	data() {
		return {
			isCollapsed: false,
			activeItem: null,
			menuTree,
			showArrow: false,
		};
	},
	computed: {
		...mapGetters({
			fiskalniPokladnyEnabled: FISKAL_MODE_ENABLED,
		}),
		filteredMenuTree() {
			const setVisible = (item: MenuItem) => {
				item.visible = Boolean(this.loggedUser.UserMenu.find((menu: any) => item.name === menu.MenuCode));
				item.items.forEach(setVisible);
			};

			const tree = _.clone(menuTree);
			tree.items.forEach(setVisible);
			tree.items = tree.items.filter((innerItem) => innerItem.visible);

			const treeNodes = tree.items.map((item) => {
				item.items = item.items.filter((innerItem) => (innerItem.route
					? !_.includes(this.hiddenMenuItems, innerItem.route)
					: innerItem));
				return item;
			});
			return treeNodes;
		},
		hiddenMenuItems() {
			const hiddenMenuItems = [];

			if (!this.fiskalniPokladnyEnabled) {
				hiddenMenuItems.push(POKL_DOKLAD);
			}

			if (!this.dmsSys.InventoryAdjustmentPrp) {
				hiddenMenuItems.push(PARTS_INVENTORY_ADJUSTMENTS);
			}

			if (!this.dmsSys.PROrdersTogglePrp) {
				hiddenMenuItems.push(ND_OBJEDNAVKA);
			}

			if (!this.dmsSys.PROrdersPrp) {
				hiddenMenuItems.push(PR_ORDERS, PR_INVOICE, PR_RETURN);
			}

			if (!this.dmsSys.EventConfigurationPrp) {
				hiddenMenuItems.push(EVENT_CONFIGURATION);
			}

			if (!this.dmsSys.EventFrequencyPrp) {
				hiddenMenuItems.push(EVENT_FREQUENCY);
			}

			if (!this.dmsSys.CommunicationEventConfigPrp) {
				hiddenMenuItems.push(COMMUNICATION_EVENT_CONFIGURATION);
			}

			if (!this.dmsSys.WarrantyPrp) {
				hiddenMenuItems.push(SERVICE_HISTORY);
			}

			if (!this.dmsSys.ServiceDueDetailsPrp) {
				hiddenMenuItems.push(SERVICE_DUE_DETAILS);
			}

			return hiddenMenuItems;
		},
	},
	watch: {
		$route: {
			immediate: true,
			handler() {
				// Change active depends to root or first page
				if (this.$store.state.pageManager.pages.length === 0 || this.$store.state.pageManager.pages.length === 1) {
					this.activeItem = this.$route.meta.objectName || this.$route.name;
				}
			},
		},
	},
	methods: {
		handleToggle() {
			this.isCollapsed = !this.isCollapsed;
		},
		scrollNavbar(direction: string) {
			let content = document.querySelector(".el-menu--horizontal");
			if (content !== null)
				if (direction === 'right')
					content.scrollLeft += 250;
				else
					content.scrollLeft -= 250;
		},
		getWidth() {
			this.showArrow = window.innerWidth < 1630;
		}
	},
	created() {
		window.addEventListener("resize", this.getWidth);
	},
	destroyed() {
		window.removeEventListener("resize", this.getWidth);
	},
});
